module.exports = __webpack_public_path__ + "img/index-ld3.62de6080.png";